import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useAccessToken } from "modules/common";
import { toast } from "react-toastify";
import { uploadBloomCalendar } from "services/beekeeping";

export const useUploadBloomCalendar = () => {
    const accessToken = useAccessToken();
    const queryClient = useQueryClient();
    const errorHandler = (error: AxiosError) => {
        const responseText = error.response?.data.message as string;
        if (responseText) {
            toast.error(responseText);
        } else {
            toast.error("Greška pri spremanju kalendara cvatnje");
        }
    };
    return useMutation({
        mutationFn: (uploadedFile: File | null) => uploadBloomCalendar(uploadedFile, accessToken!),
        onError: errorHandler,
        onSuccess: () => {
            queryClient.invalidateQueries(["beekeeping"]);
            toast.success("Kalendar cvatnje je uspješno spremljen");
        },
    });
};
